
// Metadata for the armpit cysts article
export const armpitCystsMetadata = {
  id: "armpit-cysts-guide",
  slug: "understanding-armpit-cysts",
  title: "Understanding Armpit Cysts: Causes, Symptoms and Treatment Options",
  excerpt: "Learn about the common causes of armpit cysts, how to identify symptoms, and explore effective treatment options for relief.",
  publishedAt: "June 18, 2023",
  readTime: "9 min read",
  category: "Health",
  image: "/lovable-uploads/650a9c42-cc64-48c3-bca7-c4074d812e1a.png",
  metaDescription: "Discover the causes and symptoms of armpit cysts, along with medical and home treatment options. Learn when to see a doctor and how to prevent recurrence.",
  keywords: ["armpit cysts", "underarm lumps", "hidradenitis suppurativa", "sebaceous cyst", "lymph nodes", "armpit abscess", "cyst drainage", "armpit hygiene"],
};
